import { useTranslation } from "react-i18next";
import ShipmentUpdateIcon from "../../../../icons/shipmentUpdateIcon";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import { primaryColor } from "../../../../utils";

const LatestUpdates = () => {
  const notifications = [
    {
      id: 1,
      type: "statusUpdate",
      message: "تم تحديث حالة الشحنة #ORDERID02 إلى “في الميناء”",
      time: "3:30 PM",
      title: "تحديث حالة الشحنة",
    },
    {
      id: 2,
      type: "delivered",
      message: "تم تسليم الشحنة #ORDERID01 بنجاح إلى العميل",
      time: "1 AM",
      title: "تم تسليم الشحنة",
    },
  ];
  const { t } = useTranslation();
  return (
    <div className="w-full p-5 capitalize bg-white dark:bg-gray-900 lg:w-auto rounded-2xl">
      <h2 className="py-5 text-xl font-bold text-black border-b border-black dark:border-gray-700 dark:text-white">
        {t("latestUpdates")}
      </h2>
      {notifications.map((n, i) => {
        const color =
          n.type === "statusUpdate"
            ? "bg-[#EFF6FF] dark:bg-blue-950"
            : n.type === "delivered"
            ? "bg-[#F0FDF4] dark:bg-green-950"
            : "";
        const icon =
          n.type === "statusUpdate" ? (
            <ShipmentUpdateIcon />
          ) : n.type === "delivered" ? (
            <ShipmentDeliveredIcon />
          ) : (
            ""
          );
        return (
          <div key={i} className="py-5 border-b border-black dark:border-gray-700">
            <div className={`flex gap-4 p-5 rounded-xl ${color}`}>
              <div>{icon}</div>
              <div>
                <h2 className="text-xl font-medium text-black dark:text-white">
                  {n.title}
                </h2>
                <p className="text-lg text-mainGray dark:text-gray-400">{n.message}</p>
                <span className="text-[10px] text-mainGray dark:text-gray-500">
                  {n.time}
                </span>
              </div>
            </div>
          </div>
        );
      })}
      <button
        className="block w-full py-4 text-xl font-medium text-center"
        style={{ color: primaryColor }}
      >
        {t("showMore")}
      </button>
    </div>
  );
};

export default LatestUpdates;
